import { carConfigurationActions } from '../../store/reducers/carConfigurationReducer';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';
import { useCallback } from 'react';

const useSelectedPacks = () => {
  const dispatch = useDispatch();
  const selectedPacks = useSelector(carConfigurationSelectors.getSelectedAccessoryPacks);

  const setAndReturnPacks = useCallback(
    (optionId: string) => {
      let packs: string[];
      if (selectedPacks?.includes(optionId)) {
        dispatch(carConfigurationActions.removeAccessoryPack(optionId));
        packs = selectedPacks.filter((pack: string) => pack !== optionId);
      } else {
        dispatch(carConfigurationActions.addAccessoryPack(optionId));
        packs = [...selectedPacks, optionId];
      }

      return packs;
    },
    [selectedPacks],
  );

  return { setAndReturnPacks };
};

export default useSelectedPacks;
